import { Toast, useToast } from "@oysterhr/ui"
import { ReactNode } from "react"
import { useTranslation } from "react-i18next"

export type DisplaySuccessToastArgs = {
  content?: ReactNode
  title?: string | null
}

export function useSuccessToast() {
  const toast = useToast()
  const [t] = useTranslation("DefaultToastContents")

  return ({ content = t("success.content"), title }: DisplaySuccessToastArgs) => {
    toast({
      render: (
        <Toast isCloseable variation="success">
          {title && <Toast.Title>{title}</Toast.Title>}
          <Toast.Content>{content}</Toast.Content>
        </Toast>
      ),
    })
  }
}
